"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jwt_decode_1 = __importDefault(require("jwt-decode"));
var JWTMemory = /** @class */ (function () {
    function JWTMemory() {
        this.jwt_token;
        this.claims;
    }
    JWTMemory.prototype.setJWT = function (jwt_token) {
        this.jwt_token = jwt_token;
        var jwt_token_ecoded = jwt_decode_1.default(jwt_token);
        this.claims = jwt_token_ecoded["https://hasura.io/jwt/claims"];
    };
    JWTMemory.prototype.getJWT = function () {
        return this.jwt_token;
    };
    JWTMemory.prototype.getClaim = function (claim) {
        return this.claims[claim];
    };
    JWTMemory.prototype.clearJWT = function () {
        this.jwt_token = "";
    };
    return JWTMemory;
}());
exports.default = JWTMemory;
//# sourceMappingURL=JWTMemory.js.map